if (!customElements.get('glimtiq-desktop-menu')) {
  customElements.define('glimtiq-desktop-menu', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.items = [...this.querySelectorAll('.gdm-item')];
      this.items.forEach((item) => {
        const button = item.querySelector('button');
        if (!button) return;
        item.addEventListener('pointerenter', () => {
          if (matchMedia('(hover: hover) and (pointer: fine)').matches) this.open(item);
        }, options);
        item.addEventListener('pointerleave', () => { this.timer = setTimeout(() => { if (!item.contains(document.activeElement)) this.close(); }, 140); }, options);
        item.addEventListener('focusin', (event) => { if (event.target !== button) this.open(item); }, options);
        item.addEventListener('focusout', (event) => { if (!item.contains(event.relatedTarget)) this.close(); }, options);
        button.addEventListener('click', () => { if (item.hasAttribute('data-open')) this.close(); else this.open(item); }, options);
      });
      this.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          const button = this.querySelector('[data-open] button');
          if (button) { event.preventDefault(); button.focus(); this.close(); }
        }
      }, options);
      document.addEventListener('pointerdown', (event) => { if (!this.contains(event.target)) this.close(); }, options);
    }
    open(item) { this.close(); item.setAttribute('data-open', ''); item.querySelector('button').setAttribute('aria-expanded', 'true'); }
    close() { clearTimeout(this.timer); this.items.forEach((item) => { item.removeAttribute('data-open'); item.querySelector('button')?.setAttribute('aria-expanded', 'false'); }); }
    disconnectedCallback() { clearTimeout(this.timer); this.controller?.abort(); }
  });
}
